import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - logo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * @example
 * const App = () => (
 *    <CRM
 *       logo="./img/logo.png"
 *       title="Acme CRM"
 *    />
 * );
 */
// disableTelemetry desliga o pixel para atomic-crm-telemetry.marmelab.com
// que o CRM dispara em produção (CRM.tsx). O shadcn-admin-kit-telemetry
// já é desligado pelo CRM ao repassar `disableTelemetry` para o <Admin>.
// Decisão FaroMarket: não enviar telemetria do nosso domínio ao upstream.
const App = () => <CRM disableTelemetry />;

export default App;
